<template>
    <div class="add-customer-form">
        <el-form :label-position="labelPosition" label-width="140px">
            <el-form-item label="商机名称：" required>
                <el-input size="medium" v-model="form.businessName" placeholder="请输入商机名称"></el-input>
            </el-form-item>
            <el-form-item label="领域：" required>
                <el-select 
                    placeholder="请选择" 
                    size="medium"
                    v-model="form.domainId" 
                    style="width: 100%"
                    @change="getOptionServiceStage"
                >
                    <el-option 
                        v-for="(item,index) in domianList"
                        :value="item.domainid" 
                        :label="item.domainname" 
                        :key="index" 
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="项目类型：" required>
                <el-select 
                    size="medium" 
                    v-model="form.serviceStageId" 
                    placeholder="请选择" 
                    style="width: 100%;"
                >
                    <el-option 
                        v-for="(item,index) in serviceStageList"
                        :value="item.servicestageid" 
                        :label="item.servicestagename" 
                        :key="index" 
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="对应客户：" required>
                <el-select 
                    size="medium"
                    value-key="custId" 
                    filterable
                    v-model="form.custObj" 
                    placeholder="请选择" 
                    style="width: 100%"
                >
                    <el-option 
                        v-for="(item,index) in dykhList"
                        :label="item.custName" 
                        :value="item"
                        :key="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="预计成单金额：">
                <el-input size="medium" v-model="form.preOrderAmount" placeholder="请输入预计成单金额（元）"></el-input>
            </el-form-item>
            <el-form-item label="商机进度：" >
                <el-select size="medium" v-model="form.businessProgId" placeholder="请选择" style="width: 100%;">
                    <el-option :value="1" label="初步接洽"></el-option>
                    <el-option :value="2" label="需求确认"></el-option>
                    <el-option :value="3" label="意向发单"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="预计成单日期：" >
                <el-date-picker
                    size="medium"
                    v-model="form.preOrderDate"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 100%;"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="负责人：" >
                <el-select 
                    size="medium"
                    filterable
                    v-model="form.principalId" 
                    placeholder="请选择"
                    style="width: 100%;"
                    @change="onPrincipalGetCust"
                >
                    <el-option 
                        v-for="(item,index) in fzrList"
                        :label="item.userName" 
                        :value="item.userId"
                        :key="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注：" >
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 2 }"
                    placeholder="请输入内容"
                    v-model="form.remark">
                </el-input>
            </el-form-item>
            <el-form-item label=" " style="margin-top: 30px;">
                <el-button size="medium" type="primary" @click="confirmSeas">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import { getStorageUserRoleId } from '@/utils/store'
    import {
        optionHeaders,                  //负责人
        prodDomains,                    //获取领域
        optionServiceStage,             //项目类型（服务类型）
        corCustList,                    //对应客户
    } from "@/service/customerInformation";
    export default {
        data() {
            return {
                labelPosition: 'left',
                form: {
                    businessName: '',       //商机名称
                    domainId: '',           //领域
                    serviceStageId: '',   //项目类型
                    custObj: {
                        custId: '',
                        custName: '',
                    },

                    preOrderAmount: '',     //预计成单金额
                    businessProgId: '',     //商机进度
                    preOrderDate: '',       //预计成单日期
                    principalId: '',        //负责人
                    remark: '',             //备注
                },
                domianList: [],         //领域
                serviceStageList: [],   //项目（服务）列表
                fzrList: [],            //负责人
                oraginForm: {},
                dykhList: []            //对应客户
                
            };
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
        },
        methods: {
            get(){
                this.getProdDomains();
                this.getOptionHeaders();
                this.$nextTick(()=>{
                    // this.form.principalId = Number(getStorageUserRoleId());
                    this.getCorCustList();
                })
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
            },
            // 获取领域
            getProdDomains(){
                prodDomains().then(res=>{
                    this.domianList = res.Data
                })
            },
            // 获取项目类型(通过领域id)
            getOptionServiceStage(){
                this.serviceStageList = []
                this.form.serviceStageId = ''
                let data = {
                    domainId: this.form.domainId
                }
                optionServiceStage(data).then(res=> {
                    this.serviceStageList = res.Data;
                })
            },
            // 获取负责人
            getOptionHeaders() {
                let data = {}
                data.headerType = 1
                optionHeaders(data).then(res=> {
                    this.fzrList = res.Data
                    //如果负责人列表包含登陆者，则默认登陆者
                    for (let i = 0; i < this.fzrList.length; i++) {
                        if(this.fzrList[i].userId==Number(getStorageUserRoleId())){
                            this.form.principalId = Number(getStorageUserRoleId());
                        }
                    }
                })
            },
            // 对应客户
            getCorCustList(){
                let data = {
                    // principalId: this.form.principalId,
                    keyword: '',
                }
                corCustList(data).then(res=> {
                    this.dykhList = res.Data
                })
            },
            // 点击负责人获取对应客户
            onPrincipalGetCust() {
                // this.form.custObj= {
                //     custId: '',
                //     custName: ''
                // }
                // this.dykhList = []
                // this.getCorCustList()
            },
            // 提交
            confirmSeas(){
                let data = Object.assign({}, this.form);
                if(!data.businessName) {
                    return this.$message.warning('商机名称不能为空')
                }
                if(!data.domainId) {
                    return this.$message.warning('请选择领域')
                }
                if(!data.serviceStageId) {
                    return this.$message.warning('请选择项目类型')
                }

                if(!data.custObj.custId && !data.custObj.custName) {
                    return this.$message.warning('请选择对应客户')
                }
                if(data.custObj.custId&&data.custObj.custName) {
                    data.custId = data.custObj.custId
                    data.custName = data.custObj.custName
                }
                delete data.custObj
                !data.businessProgId && delete data.businessProgId
                !data.preOrderAmount && delete data.preOrderAmount
                !data.preOrderDate && delete data.preOrderDate
                !data.remark && delete data.remark
                this.$emit('confirmSeasFun', data)
            },
        }
    }
</script>
<style lang="scss">

</style>